"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Box = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./box.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Box = function Box(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "home-content-box"
  }, _react["default"].Children.map(children, function (child) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: className ? "content ".concat(className) : 'content'
    }, child);
  }));
};

exports.Box = Box;
Box.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string
};
Box.defaultProps = {
  children: null,
  className: ''
};
var _default = Box;
exports["default"] = _default;